<template>
  <div>
    <div v-if="fieldProperties.multiple===true ||fieldProperties.multiple==='true'">
      <table style="width:100%;" class="table is-fullwidth is-bordered" ref="filesTable">
        <thead>
          <tr>
            <th>text</th>
            <th></th>
          </tr>
        </thead>
        <tr v-for="(value,index) in values" :key="index">
          <td>
             <medium-editor :text='value' @edit="editValue(index,$event)" class="input isHTML wysiwyg"  :options="options" custom-tag='div'></medium-editor>
          </td>
          <td class="has-text-centered">
            <a class="button is-danger" @click="removeValue(index)">
              <span class="icon is-small">
                <i class="fas fa-trash"></i>
              </span>
            </a>
          </td>
        </tr>
        <tr>
          <td class="field">
            <div class="control">
              <input class="input" type="text" :value="tempValue" v-if="!fieldProperties.isHTML" />
              <div v-else>
                <medium-editor
                  :text="inputValue"
                  @edit="operation => inputValue=operation.api.origElements.innerHTML"
                  class="input isHTML wysiwyg"
                  :options="options"
                  custom-tag="div"
                ></medium-editor>
              </div>
            </div>
          </td>
          <td class="has-text-centered">
            <a class="button is-success" @click="addValue">
              <span class="icon is-small">
                <i class="fas fa-plus"></i>
              </span>
            </a>
          </td>
        </tr>
      </table>
    </div>
    <div class="field" v-else>
      <div class="control">
        <input
          class="input"
          type="text"
          :value="tempValue"
          @input="emitInputChange($event.target.value)"
          v-if="!fieldProperties.isHTML"
        />
        <div v-else>
          <medium-editor
            :text="tempValue"
            class="input isHTML wysiwyg"
            @edit="debouncedTrigger"
            :options="options"
            custom-tag="div"
          ></medium-editor>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { inputProps } from '@/mixins/FormInputMixin'
import editor from 'vue2-medium-editor'
import _ from 'underscore'
export default {
  name: 'form-text',
  mixins: [inputProps],
  components: { 'medium-editor': editor },
  data () {
    return {
      // values: [],
      inputValue: '',
      options: {
        disableExtraSpaces: true,
        placeholder: {
          text: 'Puedes editar este contenido',
          hideOnClick: true
        },
        paste: {
          cleanPastedHTML: true,
          forcePlainText: true
        }

      }
    }
  },
  computed: {
    tempValue: function () {
      if (this.fieldProperties.multiple === 'true') {
        return ''
      } else {
        return this.value
      }
    },
    values: function () {
      if (this.fieldProperties.multiple === 'true') {
        return !_.isString(this.value)
          ? _.toArray(this.value)
          : this.value.length > 0
            ? [this.value]
            : []
      } else {
        return this.value
      }
    }
  },
  methods: {
    debouncedTrigger: _.debounce(function (operation) {
      this.$emit('input', operation.api.origElements.innerHTML)
    }, 500),
    emitInputChange: function (value) {
      this.$emit('input', value)
    },
    editValue (index, operation) {
      this.values[index] = operation.api.origElements.innerHTML
      this.emitInputChange(this.values)
    },
    addValue: function () {
      this.values.push(this.inputValue)
      this.emitInputChange(this.values)
      this.inputValue = ''
    },
    removeValue: function (index) {
      this.values.splice(index, 1)
      this.emitInputChange(this.values)
    }
  }
}
</script>

<style scoped>
.input{
  height: unset;
}
</style>
